import { withStyles } from '@material-ui/core/styles';
import styles from './ImageUploader.styles';
import ImageUploader from './ImageUploader';

export default withStyles(styles)(ImageUploader);
